module.exports = __webpack_public_path__ + "assets/9d172b731f6a6600a2f3303b3e5865d9.mp3";